import type { ApiClientV2Default } from 'utils/api-client/api-client.utils'
import { FromSwagger } from 'types/helpers'
import { WebSdkSessionAttributes, SalesTeamMemberCabinetWebSdkSessionAttributes } from 'types/__generated__/api'

export interface ResolveSessionParams {
  session_id: string
}

export interface ResolveSalesTeamSessionParams extends ResolveSessionParams {
  sales_team_id: number
}

export type ShopWebSdkSessionAttributes = FromSwagger<WebSdkSessionAttributes>

// TODO: remove it after updating swagger
export type SalesTeamMemberWebSdkSessionFlowData = {
  payer: {
    email: string
    firstName: string
    lastName: string
  }
}

export type SalesTeamMemberWebSdkSessionAttributes = Omit<
  FromSwagger<SalesTeamMemberCabinetWebSdkSessionAttributes>,
  'flowData'
> & {
  flowData: SalesTeamMemberWebSdkSessionFlowData
}

export type ResolveWebSdkSessionResponse = ShopWebSdkSessionAttributes | SalesTeamMemberWebSdkSessionAttributes

export const createPartnerApi = ({ GET }: ApiClientV2Default) => ({
  // Shop flavor: flat, unscoped.
  resolveShopWebSdkSession: ({ session_id }: ResolveSessionParams) =>
    GET<ResolveWebSdkSessionResponse>('/shop/web-sdk-session', { session_id }),

  // Sales-team flavor: scoped by the currently selected team. sales_team_id is required by the
  // type; the "no team selected" / NaN case is guarded in PartnerStore.resolveSalesTeamSession.
  resolveSalesTeamWebSdkSession: ({ session_id, sales_team_id }: ResolveSalesTeamSessionParams) =>
    GET<ResolveWebSdkSessionResponse>(`/sales_team_member/sales_teams/${sales_team_id}/web-sdk-session`, {
      session_id,
    }),
})

export type PartnerApi = ReturnType<typeof createPartnerApi>
